/*
 * Company facts for structured data and llms.txt. Mirrors the marketing site
 * (src/content/site.ts there): change a fact there first, then here.
 * CommonJS: data/generate-llms.js requires it at build time.
 */
const MARKETING_URL = 'https://www.bidali.com';

const company = {
  name: 'Bidali',
  legalName: 'Bidali Inc.',
  foundedYear: 2018,
  url: MARKETING_URL,
  storeUrl: 'https://giftcards.bidali.com',
  logo: 'https://assets.bidali.com/company/bidali/logo.png',
  address: {
    street: '#300 - 1550 5 St SW',
    locality: 'Calgary',
    region: 'AB',
    postalCode: 'T2R 1K3',
    country: 'Canada',
    countryCode: 'CA',
    formatted: '#300 - 1550 5 St SW, Calgary, AB T2R 1K3, Canada',
  },
  phone: '+1 (855) 886-4830',
  socials: {
    linkedin: 'https://linkedin.com/company/bidali',
    x: 'https://x.com/bidalihq',
    instagram: 'https://instagram.com/bidalihq',
    facebook: 'https://facebook.com/bidalihq',
  },
  urls: {
    docs: 'https://docs.bidali.com',
    support: 'https://support.bidali.com',
  },
  supportEmail: 'support.spend@bidali.com',
  legal: {
    terms: `${MARKETING_URL}/legal/terms`,
    privacy: `${MARKETING_URL}/legal/privacy`,
    cookies: `${MARKETING_URL}/legal/cookies`,
    restrictedUse: `${MARKETING_URL}/legal/restricted-use`,
    rewards: `${MARKETING_URL}/legal/cashback`,
    compliance: `${MARKETING_URL}/legal/aml`,
  },
};

module.exports = company;
